import { Fragment } from "preact";
import { useContext } from "preact/hooks";
import { Text } from "preact-i18n";

import { Configs } from "../../helpers/context";
import { formatIntegerCurrencyString } from "../../helpers/formatters";

const LegacyOrderSummaryItem = ({ item, isCheckoutPage = false }) => {
  const configsContext = useContext(Configs);
  const lineItemAmount = (item.unitPrice || 0) * (item.quantity || 1);

  return (
    <Fragment>
      <div className={isCheckoutPage ? "order-description-checkout" : "order-description"}>
        <span className="order-title">
          {item.name}
        </span>
        <span className="order-quantity">
          {item.quantity}
        </span>
        {!isCheckoutPage && (
          <span className="order-unit price">
            {item.unitPrice
              ? formatIntegerCurrencyString(
                  item.unitPrice,
                  configsContext?.configs?.currency,
                  configsContext?.configs?.ecommerceLocaleLanguage,
                )
              : ""}
          </span>
        )}
        <span className="cart-size">
          {formatIntegerCurrencyString(
            lineItemAmount,
            configsContext?.configs?.currency,
            configsContext?.configs?.ecommerceLocaleLanguage,
          )}
        </span>
      </div>
      <div style="clear: both;"></div>
      {item.unitPrice && !isCheckoutPage ? (
        <div className="mobile-price">
          <br />
          <div>
            <span>
              <Text id="ORDER_ITEM_UNIT_PRICE">Unit Price: </Text>
            </span>
            <span>
              {item.unitPrice
                ? formatIntegerCurrencyString(
                    item.unitPrice,
                    configsContext?.configs?.currency,
                    configsContext?.configs?.ecommerceLocaleLanguage,
                  )
                : ""}
            </span>
          </div>
        </div>
      ) : null}
      {item.selectedVariants?.[0]?.selectableVariations?.length ? (
        <div className="order-modifiers">
          {item.selectedVariants?.[0]?.selectableVariations.map((variation, i) => {
            return (
              <span className="modifiers">
                {i ? " | " : ""}
                {variation.values.map((value) => value.name).join(", ")}
              </span>
            );
          })}
        </div>
      ) : null}
    </Fragment>
  );
};

export default LegacyOrderSummaryItem;
